export default __webpack_public_path__ + "static/media/Lexar.d0471cfa.svg";